export default __webpack_public_path__ + "static/media/team-02.7845ccce.png";